import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

import styles from './whatsapp-button.module.scss';

export const WhatsappButton = () => (
  <div className={styles.container}>
    <a
      aria-label="whatsapp-link"
      href="https://api.whatsapp.com/send?phone=56999846063&text=IDAW-Hola,%20me%20gustar%C3%ADa%20recibir%20asesoramiento."
      rel="noreferrer"
      target="_blank">
      <FaWhatsapp className={styles.icon} />
    </a>
  </div>
);
